import { render, staticRenderFns } from "./OtherPropertyCarInsurance.vue?vue&type=template&id=fc7fa0a2"
import script from "./OtherPropertyCarInsurance.vue?vue&type=script&lang=js"
export * from "./OtherPropertyCarInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports